import {
  Component, EventEmitter, HostBinding, Input, OnChanges, Output, ViewEncapsulation, SimpleChanges, ChangeDetectionStrategy
} from '@angular/core';

import {
  IExtendedLink,
  ILinkMedia,
  PositionEnum, SdBannerComponent, SdRichParagraphComponent, SdThemeComponent, SdTitleComponent
} from '@seb/web-design-system/core';

import type { IApplication } from './applications.interface';

@Component({
  selector: 'sd-applications',
  templateUrl: './applications.component.html',
  styleUrls: ['./applications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdRichParagraphComponent,
    SdTitleComponent,
    SdBannerComponent
  ]
})
export class SdApplicationsComponent extends SdThemeComponent implements OnChanges {
  @Input()
  applicationData: IApplication;

  /**
   * Allow to define if the main text is on the left or on the right of the main content
   * * @param {string} left | right
   */
  @Input()
  layoutTextConfig: PositionEnum.left | PositionEnum.right = PositionEnum.right;

  @Input()
  twicPicsAutoSize = true;

  @Output()
  linkClicked = new EventEmitter<IExtendedLink | ILinkMedia>();

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.layoutTextConfig ? 'is-align-' + this.layoutTextConfig : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  customClass: string;

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    const themesClass = this.applicationData?.themesConfig
      ? 'is-theme-' + this.applicationData?.themesConfig
      : 'is-theme-light';
    const layoutClass = this.applicationData?.titlePosition
      ? 'is-position-' + this.applicationData?.titlePosition
      : 'is-position-top';
    this.customClass = themesClass + ' ' + layoutClass;
  }

  clicked(event: { link: IExtendedLink | ILinkMedia }) {
    this.linkClicked.emit(event.link);
  }
}
